<template>
  <LLWordTextContainer class="PrivacyPolicyJA">
    <p class="c11">
      <span class="c0"
        >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#65288;&#20491;&#20154;&#24773;&#22577;&#65289;&#12434;&#20445;&#35703;&#12377;&#12427;&#12371;&#12392;&#12364;&#24403;&#31038;&#12398;&#26368;&#20778;&#20808;&#20107;&#38917;&#12391;&#12377;&#12290;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12399;&#12289;</span
      ><span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=http://spark-nyc.com&amp;sa=D&amp;source=editors&amp;ust=1666017342995706&amp;usg=AOvVaw1KP655BgC-eR9xf7X1DTM9"
          >spark-nyc.com</a
        ></span
      ><span class="c0">&#12362;&#12424;&#12403;</span
      ><span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://looklook.app&amp;sa=D&amp;source=editors&amp;ust=1666017342995966&amp;usg=AOvVaw2m9_kacvLX5jzZKNNTAfFo"
          >looklook.app</a
        ></span
      ><span class="c2 c0"
        >&#65288;&#38598;&#32004;&#30340;&#12395;&#12289;&#12300;&#21508;&#12469;&#12452;&#12488;&#12301;&#65289;&#12394;&#12425;&#12403;&#12395;LookLook&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12465;&#12540;&#12471;&#12519;&#12531;&#65288;&#12300;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12301;&#65288;APP&#65289;&#12301;&#12434;&#21547;&#12416;&#12289;Spark
        Ideas, LLC
        (&#12300;Spark&#12301;&#12289;&#12300;&#24403;&#31038;&#12301;&#12289;&#12300;&#25105;&#12293;&#12301;&#12289;&#12300;&#31169;&#12383;&#12385;&#12301;&#12414;&#12383;&#12399;&#12300;&#24403;&#31038;&#12398;&#12301;&#31561;&#12293;&#65289;&#12398;&#32113;&#21046;&#19979;&#12395;&#12354;&#12427;&#12289;&#12454;&#12455;&#12502;&#12469;&#12452;&#12488;&#12289;&#12450;&#12503;&#12522;&#12362;&#12424;&#12403;&#12469;&#12540;&#12499;&#12473;&#12395;&#36969;&#29992;&#12373;&#12428;&#12414;&#12377;&#12469;&#12452;&#12488;&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#20351;&#29992;&#12377;&#12427;&#12371;&#12392;&#12395;&#12424;&#12426;&#12289;&#12371;&#12398;&#22768;&#26126;&#12395;&#35352;&#36617;&#12373;&#12428;&#12383;&#12487;&#12540;&#12479;&#12398;&#21462;&#25201;&#12395;&#21516;&#24847;&#12375;&#12383;&#12371;&#12392;&#12392;&#12394;&#12427;&#12383;&#12417;&#12289;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12434;&#27880;&#24847;&#28145;&#12367;&#12362;&#35501;&#12415;&#12367;&#12384;&#12373;&#12356;&#12290;</span
      >
    </p>
    <p class="c11 c10"><span class="c2 c0"></span></p>
    <p class="c11">
      <span class="c0"
        >&#12373;&#12425;&#12395;&#12289;&#12362;&#23458;&#27096;&#12398;&#26412;&#12469;&#12452;&#12488;&#12414;&#12383;&#12399;&#12381;&#12398;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12398;&#12372;&#21033;&#29992;&#12418;</span
      ><span class="c7 c0"
        >&#12289;&#12371;&#12371;&#12434;&#12463;&#12522;&#12483;&#12463;&#12377;&#12427;&#12371;&#12392;&#12391;</span
      ><span class="c0"
        >&#34920;&#31034;&#12373;&#12428;&#12427;&#26412;&#12300;&#21033;&#29992;&#35215;&#32004;&#12301;&#12398;&#36969;&#29992;&#23550;&#35937;&#12391;&#12377;&#12290;
      </span>
    </p>
    <p class="c19">
      <span class="c29">&#37325;&#35201;&#12394;&#36890;&#30693;</span
      ><span class="c0 c32"
        >&#27861;&#24459;&#12391;&#31105;&#27490;&#12373;&#12428;&#12390;&#12356;&#12427;&#29366;&#27841;&#12392;&#31684;&#22258;&#12434;&#38500;&#12365;&#12289;Spark
        &#12395;&#23550;&#12377;&#12427;&#20491;&#20154;&#35380;&#35359;&#12398;&#30003;&#31435;&#12434;&#21336;&#29420;&#12391;&#20210;&#35009;&#12377;&#12427;&#24517;&#35201;&#12364;&#12354;&#12427;&#19979;&#35352;&#12398;&#20210;&#35009;&#26465;&#38917;&#12395;&#27880;&#24847;&#12375;&#12390;&#12367;&#12384;&#12373;&#12356;&#12290;&#20491;&#20154;&#35380;&#35359;&#12391;&#12398;&#20210;&#35009;&#12392;&#12399;&#12289;&#12362;&#23458;&#27096;&#12364;&#12289;&#35009;&#21028;&#23448;&#12414;&#12383;&#12399;&#38506;&#23529;&#21729;&#12398;&#30003;&#31435;&#12434;&#27770;&#23450;&#12377;&#12427;&#27177;&#21033;&#12434;&#25345;&#12388;&#12371;&#12392;&#12395;&#12394;&#12425;&#12378;&#12289;&#12381;&#12428;&#12434;&#25918;&#26820;&#12377;&#12427;&#12371;&#12392;&#12434;&#24847;&#21619;&#12377;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12289;&#12362;&#23458;&#27096;&#12364;&#12289;&#38598;&#22243;&#35380;&#35359;&#12289;&#22243;&#20307;&#35380;&#35359;&#12418;&#12375;&#12367;&#12399;&#20195;&#34920;&#27177;&#12398;&#34892;&#20351;&#12434;&#32154;&#34892;&#12377;&#12427;&#12371;&#12392;&#12364;&#12391;&#12365;&#12394;&#12356;&#12371;&#12392;&#12434;&#24847;&#21619;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c19">
      <span class="c15 c0"
        >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12398;&#21454;&#38598;&#12362;&#12424;&#12403;&#21033;&#29992;<br
      /></span>
    </p>
    <p class="c42">
      <span class="c2 c0"
        >&#12300;&#20491;&#20154;&#24773;&#22577;&#12301;&#12392;&#12399;
        1&#20491;&#12398;&#35672;&#21029;&#28168;&#12415;&#12414;&#12383;&#12399;&#35672;&#21029;&#21487;&#33021;&#12394;&#33258;&#28982;&#20154;&#12395;&#38306;&#36899;&#12377;&#12427;&#20219;&#24847;&#12398;&#24773;&#22577;&#12391;&#12377;&#12290;&#24403;&#31038;&#12399;&#12362;&#23458;&#27096;&#12363;&#12425;&#12289;&#12362;&#23458;&#27096;&#12395;&#12388;&#12356;&#12390;&#27425;&#12398;&#24773;&#22577;&#12434;&#21454;&#38598;&#12375;&#12414;&#12377;&#65306;</span
      >
    </p>
    <p class="c42 c10"><span class="c2 c0"></span></p>
    <a id="t.c78183c4bc3bca1a1a8d50d2f46f51e039975a1e"></a><a id="t.0"></a>
    <table class="c38">
      <tr class="c25">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c17 c0">&#20154;&#21475;&#32113;&#35336;&#12487;</span
            ><span class="c0 c24">&#12540;&#12479;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c17 c0">&#12371;&#12398;&#12487;</span
            ><span class="c24 c0"
              >&#12540;&#12479;&#12399;&#12289;&#20197;&#19979;&#12398;&#30446;&#30340;&#12391;&#20351;&#29992;&#12375;&#12414;&#12377;</span
            >
          </p>
        </td>
      </tr>
      <tr class="c23">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#27663;&#21517;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#38651;&#35441;&#30058;</span><span class="c7 c0">&#21495;</span
            ><span class="c0"><br /></span
            ><span class="c5 c0"
              >&#24066;&#30010;&#26449;&#12289;&#37117;&#36947;&#24220;&#30476;&#12289;</span
            ><span class="c7 c0">&#22269;&#21517;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#38651;&#23376;&#12513;</span
            ><span class="c7 c0">&#12540;&#12523;&#12450;&#12489;&#12524;&#12473;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#24441;&#32887;&#21517;</span
            ><span class="c0"><br /></span><span class="c7 c0">&#20250;&#31038;&#21517;</span
            ><span class="c0"><br /></span><span class="c7 c0">&#23398;&#27508;</span
            ><span class="c0">&nbsp;<br /></span><span class="c5 c0">&#25152;&#24471;&#38542;&#23652;</span
            ><span class="c0"><br /></span
            ><span class="c5 c0">&#37197;&#20598;&#32773;&#12398;&#26377;&#28961;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#35519;&#26619;&#12398;</span><span class="c7 c0">&#23455;&#26045;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#39015;&#23458;&#12420;&#35211;</span
            ><span class="c7 c0"
              >&#36796;&#12415;&#23458;&#12392;&#12398;&#12467;&#12511;&#12517;&#12491;&#12465;&#12540;&#12471;&#12519;&#12531;&#65288;&#12513;&#12540;&#12523;&#12289;&#12467;&#12531;&#12479;&#12463;&#12488;&#12501;&#12457;&#12540;&#12512;&#12289;</span
            ><span class="c0">WeChat)<br /></span><span class="c5 c0">&#12362;&#23458;</span
            ><span class="c7 c0"
              >&#27096;&#12364;&#12522;&#12469;&#12540;&#12481;&#12503;&#12521;&#12483;&#12488;&#12501;&#12457;&#12540;&#12512;&#12434;&#20351;&#29992;&#12391;&#12365;&#12427;&#12424;&#12358;&#12395;&#12377;&#12427;</span
            ><span class="c0">&nbsp;<br /></span
            ><span class="c5 c0">&#21839;&#38988;&#12398;&#35299;&#27770;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#12459;&#12473;&#12479;&#12510;</span
            ><span class="c7 c0">&#12540;&#12469;&#12509;&#12540;&#12488;&#12398;&#25552;&#20379;</span
            ><span class="c0"
              ><br />
              <br />
              <br /> </span
            ><span class="c5 c0">&#27861;&#30340;&#26681;</span
            ><span class="c7 c0"
              >&#25312;&#65306;&#21516;&#24847;&#12289;&#22865;&#32004;&#12289;&#27491;&#24403;&#12394;&#21033;&#30410;</span
            >
          </p>
        </td>
      </tr>
      <tr class="c25">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4"><span class="c17 c0">&#20491;&#20154;&#12398;&#36259;&#21619;</span></p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4"><span class="c2 c0">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c41">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#36259;&#21619;</span><span class="c0"><br /></span
            ><span class="c7 c0">&#38306;&#24515;&#20107;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#36023;&#12356;&#29289;&#32722;&#24931;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#12502;&#12521;&#12531;&#12489;&#12398;&#22909;&#12415;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#36092;&#20837;&#23653;</span
            ><span class="c7 c0">&#27508;</span><span class="c0"><br /></span
            ><span class="c5 c0"
              >&#12381;&#12398;&#20182;&#35519;&#26619;&#12395;&#24517;&#35201;&#12394;&#20107;&#38917;</span
            >
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#35519;&#26619;&#12398;</span><span class="c7 c0">&#23455;&#26045;</span
            ><span class="c0"><br /><br /></span><span class="c5 c0">&#27861;&#30340;&#26681;</span
            ><span class="c7 c0">&#25312;&#65306;&#21516;&#24847;</span>
          </p>
        </td>
      </tr>
      <tr class="c25">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c0 c17">&#12513;&#12487;&#12451;&#12450;&#12501;&#12449;&#12452;&#12523;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4"><span class="c2 c0">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c39">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c7 c0">&#20889;&#30495;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#21205;</span><span class="c7 c0">&#30011;</span
            ><span class="c0">&nbsp;<br /></span><span class="c5 c0">&#38899;</span
            ><span class="c7 c0">&#22768;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#35519;&#26619;&#12398;</span><span class="c7 c0">&#23455;&#26045;</span
            ><span class="c0"><br /><br /></span><span class="c5 c0">&#27861;&#30340;&#26681;</span
            ><span class="c7 c0">&#25312;&#65306;&#21516;&#24847;</span>
          </p>
        </td>
      </tr>
      <tr class="c25">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c17 c0">&#12467;&#12511;&#12517;&#12491;&#12465;</span
            ><span class="c24 c0">&#12540;&#12471;&#12519;&#12531;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4"><span class="c2 c0">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c40">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c7 c0">&#21442;&#21152;&#32773;&#12452;&#12531;&#12479;&#12499;&#12517;&#12540;</span
            ><span class="c0"><br /></span
            ><span class="c5 c0"
              >&#19968;&#33324;&#30340;&#12394;&#12362;&#21839;&#12356;&#21512;&#12431;&#12379;&#65288;&#12362;&#23458;</span
            ><span class="c0 c7"
              >&#27096;&#12363;&#12425;&#12398;&#12372;&#35201;&#26395;&#12434;&#12513;&#12540;&#12523;&#12420;&#31379;&#21475;&#12391;&#12362;&#21463;&#12369;&#12375;&#12390;&#12356;&#12414;&#12377;&#65289;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#12459;&#12473;&#12479;&#12510;</span
            ><span class="c7 c0">&#12540;&#12469;&#12509;&#12540;&#12488;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#35519;&#26619;&#12398;</span><span class="c7 c0">&#23455;&#26045;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#39015;&#23458;&#12420;&#35211;</span
            ><span class="c7 c0"
              >&#36796;&#12415;&#23458;&#12392;&#12398;&#12467;&#12511;&#12517;&#12491;&#12465;&#12540;&#12471;&#12519;&#12531;&#65288;</span
            ><span class="c0">E</span><span class="c5 c0">&#12513;</span
            ><span class="c7 c0"
              >&#12540;&#12523;&#12289;&#12467;&#12531;&#12479;&#12463;&#12488;&#12501;&#12457;&#12540;&#12512;&#12289;</span
            ><span class="c0">WeChat</span><span class="c5 c0">&#65289;</span><span class="c0"><br /></span
            ><span class="c5 c0">&#12459;&#12473;&#12479;&#12510;</span
            ><span class="c7 c0">&#12540;&#12469;&#12509;&#12540;&#12488;&#12398;&#25552;&#20379;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#35613;</span
            ><span class="c7 c0">&#31036;&#12398;&#37197;&#24067;</span><span class="c0"><br /><br /></span
            ><span class="c5 c0">&#27861;&#30340;&#26681;</span
            ><span class="c7 c0"
              >&#25312;&#65306;&#21516;&#24847;&#12289;&#27491;&#24403;&#12394;&#21033;&#30410;</span
            >
          </p>
        </td>
      </tr>
      <tr class="c25">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4"><span class="c17 c0">&#25216;&#34899;&#32057;&#20171;</span></p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4"><span class="c2 c0">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c40">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#37117;&#24066;&#12398;&#12472;&#12458;&#12525;&#12465;</span
            ><span class="c7 c0">&#12540;&#12471;&#12519;&#12531;</span><span class="c0"><br />IP</span
            ><span class="c5 c0">&#12450;&#12489;&#12524;&#12473;</span><span class="c0"><br /></span
            ><span class="c5 c0"
              >&#12487;&#12496;&#12452;&#12473;&#12362;&#12424;&#12403;&#12502;&#12521;&#12454;&#12470;&#12398;&#12487;</span
            ><span class="c7 c0">&#12540;&#12479;</span>
          </p>
        </td>
        <td class="c21" colspan="1" rowspan="1">
          <p class="c4">
            <span class="c5 c0">&#35519;&#26619;&#12398;</span><span class="c7 c0">&#23455;&#26045;</span
            ><span class="c0"><br /></span><span class="c5 c0">&#12362;&#23458;</span
            ><span class="c7 c0"
              >&#27096;&#12395;&#12424;&#12427;&#30740;&#31350;&#22522;&#30436;&#12398;&#21033;&#29992;</span
            ><span class="c0">&nbsp;<br /></span><span class="c5 c0">&#35069;&#21697;</span
            ><span class="c7 c0">&#12539;&#12469;&#12540;&#12499;&#12473;&#12398;&#25913;&#21892;</span
            ><span class="c0">&nbsp;<br /></span><span class="c5 c0">&#35506;&#38988;&#35299;&#27770;</span
            ><span class="c0"><br /></span
            ><span class="c5 c0">&#12503;&#12521;&#12483;&#12488;&#12501;&#12457;</span
            ><span class="c7 c0">&#12540;&#12512;&#12398;&#23433;&#20840;&#24615;&#30906;&#20445;</span
            ><span class="c0"><br /><br /></span><span class="c5 c0">&#27861;&#30340;&#26681;</span
            ><span class="c7 c0"
              >&#25312;&#65306;&#21516;&#24847;&#12289;&#27491;&#24403;&#12394;&#21033;&#30410;</span
            >
          </p>
        </td>
      </tr>
    </table>

    <p class="c4">
      <span class="c15 c0"
        >Cookie
        &#12362;&#12424;&#12403;&#12381;&#12398;&#20182;&#12398;&#21516;&#27096;&#12398;&#25216;&#34899;</span
      >
    </p>
    <p class="c4">
      <span class="c2 c0"
        >&#24403;&#31038;&#12399;&#24773;&#22577;&#21454;&#38598;&#12434;&#25903;&#25588;&#12377;&#12427;&#12383;&#12417;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12391;
        Cookie
        &#12362;&#12424;&#12403;&#12381;&#12398;&#20182;&#12398;&#21516;&#27096;&#12398;&#25216;&#34899;&#12434;&#20351;&#29992;&#12375;&#12414;&#12377;&#12290;&#12475;&#12483;&#12471;&#12519;&#12531;
        Cookie &#12414;&#12383;&#12399;&#27704;&#32154;&#30340;&#12394; Cookie
        &#12434;&#20351;&#29992;&#12377;&#12427;&#21487;&#33021;&#24615;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#12475;&#12483;&#12471;&#12519;&#12531;
        Cookie
        &#12399;&#35370;&#21839;&#12375;&#12383;&#29305;&#23450;&#12398;&#26399;&#38291;&#12398;&#12415;&#26377;&#21177;&#12392;&#12394;&#12426;&#12289;&#12502;&#12521;&#12454;&#12470;&#12540;&#12434;&#38281;&#12376;&#12427;&#12392;&#21066;&#38500;&#12373;&#12428;&#12414;&#12377;&#12290;&#27704;&#32154;&#30340;&#12394;
        Cookie
        &#12399;&#21066;&#38500;&#12289;&#12414;&#12383;&#12399;&#26399;&#38480;&#20999;&#12428;&#12395;&#12394;&#12427;&#12414;&#12391;&#12289;&#12487;&#12496;&#12452;&#12473;&#12398;&#12495;&#12540;&#12489;&#12489;&#12521;&#12452;&#12502;&#12395;&#27531;&#12426;&#12414;&#12377;&#12290;&#27425;&#12398;&#31278;&#21029;&#12398;
        Cookie &#12434;&#20351;&#29992;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <ul class="c6 lst-kix_list_5-0 start">
      <li class="c4 c27 li-bullet-0">
        <span class="c0 c22">&#24517;&#38920;&#20107;&#38917;</span
        ><span class="c2 c0"
          >&#12290;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12398;&#23433;&#20840;&#12394;&#38936;&#22495;&#12408;&#12398;&#12450;&#12463;&#12475;&#12473;&#12394;&#12393;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#20869;&#12434;&#31227;&#21205;&#12375;&#12390;&#12381;&#12398;&#27231;&#33021;&#12434;&#20351;&#29992;&#12391;&#12365;&#12427;&#12424;&#12358;&#12395;&#12377;&#12427;&#12383;&#12417;&#12289;&#19968;&#37096;&#12398;
          Cookie &#12399;&#24517;&#38920;&#12391;&#12377;&#12290;&#12371;&#12428;&#12425;&#12398; Cookie
          &#12364;&#12394;&#12356;&#12392;&#12289;&#20351;&#29992;&#12375;&#12390;&#12356;&#12427;&#12487;&#12496;&#12452;&#12473;&#12398;&#31278;&#21029;&#12395;&#22522;&#12389;&#12356;&#12383;&#36969;&#20999;&#12394;&#12467;&#12531;&#12486;&#12531;&#12484;&#12434;&#26377;&#21177;&#12395;&#12377;&#12427;&#12371;&#12392;&#12399;&#12391;&#12365;&#12414;&#12379;&#12435;&#12290;</span
        >
      </li>
      <li class="c31 c27 li-bullet-0">
        <span class="c22 c0"
          >&#12497;&#12501;&#12457;&#12540;&#12510;&#12531;&#12473;&#12392;&#20998;&#26512;</span
        ><span class="c2 c0"
          >&#12290;&#24403;&#31038;&#12399;&#12469;&#12452;&#12488;&#12420;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12398;&#12497;&#12501;&#12457;&#12540;&#12510;&#12531;&#12473;&#12434;&#25913;&#21892;&#12375;&#12289;&#22909;&#12415;&#12395;&#24540;&#12376;&#12390;&#38283;&#30330;&#12377;&#12427;&#12383;&#12417;&#12395;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12398;&#20351;&#29992;&#29366;&#27841;&#12434;&#30906;&#35469;&#12377;&#12427;&#12383;&#12417;&#12395;&#12289;Cookie
          &#12434;&#20351;&#29992;&#12375;&#12390;&#12356;&#12414;&#12377;&#12290;
          &#12463;&#12483;&#12461;&#12540;&#12434;&#36890;&#12376;&#12390;&#20491;&#20154;&#24773;&#22577;&#12364;&#21454;&#38598;&#12373;&#12428;&#12427;&#12371;&#12392;&#12399;&#12354;&#12426;&#12414;&#12379;&#12435;&#12290;</span
        >
      </li>
    </ul>
    <p class="c4">
      <span class="c0 c15"
        >&#20491;&#20154;&#24773;&#22577;&#12398;&#20849;&#26377;&#12392;&#38283;&#31034;</span
      >
    </p>
    <p class="c4">
      <span class="c2 c0"
        >&#24403;&#31038;&#12399;&#27425;&#12398;&#22580;&#21512;&#12362;&#12424;&#12403;&#20197;&#19979;&#12398;&#24403;&#20107;&#32773;&#12395;&#23550;&#12375;&#12390;&#12289;&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#20849;&#26377;&#12414;&#12383;&#12399;&#38283;&#31034;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <ul class="c6 lst-kix_list_2-0 start">
      <li class="c4 c27 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12399;&#21508;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#36890;&#12376;&#12390;&#25552;&#20379;&#12373;&#12428;&#12383;&#24773;&#22577;&#12434;&#12289;&#12510;&#12540;&#12465;&#12486;&#12451;&#12531;&#12464;&#12420;&#35519;&#26619;&#30740;&#31350;&#12289;&#12499;&#12472;&#12493;&#12473;&#12398;&#30446;&#30340;&#12391;&#12463;&#12521;&#12452;&#12450;&#12531;&#12488;&#12392;&#20849;&#26377;&#12375;&#12414;&#12377;&#12290;</span
        >
      </li>
      <li class="c31 c27 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12399;&#35519;&#26619;&#12434;&#31649;&#29702;&#12375;&#12289;&#12463;&#12521;&#12452;&#12450;&#12531;&#12488;&#12395;&#12524;&#12509;&#12540;&#12488;&#12434;&#25552;&#20379;&#12377;&#12427;&#12383;&#12417;&#12289;&#21508;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#36890;&#12376;&#12390;&#25552;&#20379;&#12373;&#12428;&#12427;&#24773;&#22577;&#12434;&#12469;&#12540;&#12489;&#12497;&#12540;&#12486;&#12451;&#12540;&#12398;&#12469;&#12540;&#12499;&#12473;&#12503;&#12525;&#12496;&#12452;&#12480;&#12540;&#12392;&#20849;&#26377;&#12375;&#12414;&#12377;&#12290;
          &#24403;&#31038;&#12398;&#31532;&#19977;&#32773;&#12469;&#12540;&#12499;&#12473;&#12503;&#12525;&#12496;&#12452;&#12480;&#12398;&#26368;&#26032;&#12398;&#12522;&#12473;&#12488;&#12399;&#12289;&#12371;&#12385;&#12425;&#12391;&#30906;&#35469;&#12391;&#12365;&#12414;&#12377;&#12290;</span
        >
      </li>
      <li class="c27 c31 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12399;&#12289;&#21512;&#20341;&#12289;&#36023;&#21454;&#12289;&#22770;&#21364;&#12289;&#30772;&#29987;&#12289;&#12362;&#12424;&#12403;&#24403;&#31038;&#12398;&#36039;&#29987;&#12398;&#20840;&#37096;&#12418;&#12375;&#12367;&#12399;&#19968;&#37096;&#12398;&#22770;&#21364;&#12434;&#21547;&#12416;&#12364;&#12371;&#12428;&#12425;&#12395;&#38480;&#23450;&#12373;&#12428;&#12394;&#12356;&#12289;&#12354;&#12425;&#12422;&#12427;&#30452;&#25509;&#30340;&#12418;&#12375;&#12367;&#12399;&#38291;&#25509;&#30340;&#12394;&#20877;&#32232;&#25104;&#12503;&#12525;&#12475;&#12473;&#12398;&#36942;&#31243;&#12391;&#12362;&#23458;&#27096;&#12398;&#24773;&#22577;&#12434;&#20849;&#26377;&#12414;&#12383;&#12399;&#36578;&#36865;&#12377;&#12427;&#22580;&#21512;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#35443;&#32048;&#12395;&#12388;&#12356;&#12390;&#12399;&#12289;&#19979;&#35352;&#12398;&#35698;&#28193;&#26465;&#38917;&#12434;&#12372;&#21442;&#29031;&#12367;&#12384;&#12373;&#12356;&#12290;
        </span>
      </li>
      <li class="c31 c27 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12399;&#31649;&#36676;&#23550;&#35937;&#27861;&#20196;&#12434;&#38918;&#23432;&#12377;&#12427;&#12383;&#12417;&#12289;&#12414;&#12383;&#12399;&#27861;&#24459;&#12398;&#35201;&#20214;&#12395;&#28310;&#25312;&#12375;&#12289;&#24403;&#31038;&#12395;&#25552;&#20379;&#12373;&#12428;&#12427;&#27861;&#30340;&#25163;&#32154;&#12395;&#24467;&#12358;&#12383;&#12417;&#12289;&#24403;&#31038;&#12398;&#27177;&#21033;&#12414;&#12383;&#12399;&#36001;&#29987;&#12434;&#20445;&#35703;&#12362;&#12424;&#12403;&#38450;&#24481;&#12377;&#12427;&#12383;&#12417;&#12289;&#12518;&#12540;&#12470;&#12540;&#12398;&#20491;&#20154;&#30340;&#12394;&#23433;&#20840;&#12434;&#20445;&#35703;&#12377;&#12427;&#12383;&#12417;&#12395;&#32202;&#24613;&#12398;&#29366;&#27841;&#12391;&#34892;&#21205;&#12377;&#12427;&#12383;&#12417;&#12289;&#12381;&#12398;&#12424;&#12358;&#12394;&#34892;&#21205;&#12364;&#24517;&#35201;&#12391;&#12354;&#12427;&#12392;&#20449;&#12376;&#12425;&#12428;&#12427;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#38283;&#31034;&#12377;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;</span
        >
      </li>
    </ul>
    <p class="c4">
      <span class="c5 c0">&#31859;</span
      ><span class="c7 c0"
        >&#22269;&#12398;&#28040;&#36027;&#32773;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#20445;&#35703;&#27861;&#12398;&#23450;&#32681;&#12395;&#12362;&#12369;&#12427;&#36009;&#22770;&#12392;&#12399;&#12289;&#37329;&#37549;&#30340;&#12289;&#22580;&#21512;&#12395;&#12424;&#12387;&#12390;&#12399;&#12381;&#12398;&#20182;&#12398;&#20385;&#20516;&#12354;&#12427;&#23550;&#20385;&#12398;&#12383;&#12417;&#12395;&#12289;&#20107;&#26989;&#32773;&#12364;&#20182;&#12398;</span
      ><span class="c0 c5"
        >&#20107;&#26989;&#32773;&#12414;&#12383;&#12399;&#31532;&#19977;&#32773;&#12395;</span
      ><span class="c7 c0"
        >&#23550;&#12375;&#12390;&#12289;&#21475;&#38957;&#12289;&#26360;&#38754;&#12289;&#38651;&#23376;&#30340;&#12414;&#12383;&#12399;&#12381;&#12398;&#20182;&#12398;&#25163;&#27573;&#12395;&#12424;&#12426;&#12289;&#28040;&#36027;&#32773;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#36009;&#22770;&#12289;&#36035;&#36024;&#12289;&#35299;&#25918;&#12289;&#38283;&#31034;&#12289;&#24195;&#12417;&#12427;&#12289;&#21033;&#29992;&#21487;&#33021;&#12395;&#12377;&#12427;&#12289;&#35698;&#28193;&#12289;&#12414;&#12383;&#12399;&#12381;&#12398;&#20182;&#12398;&#36890;&#20449;&#12434;&#34892;&#12358;&#12371;&#12392;&#12392;&#23450;&#32681;&#12373;&#12428;&#12390;&#12356;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c4">
      <span class="c7 c0"
        >&#24403;&#31038;&#12399;&#12289;&#31859;&#22269;&#12398;&#20491;&#20154;&#24773;&#22577;&#20445;&#35703;&#27861;&#12391;&#23450;&#32681;&#12373;&#12428;&#12427;&#20491;&#20154;&#24773;&#22577;&#12434;&#36009;&#22770;&#12377;&#12427;&#12371;&#12392;&#12399;&#12354;&#12426;&#12414;&#12379;&#12435;&#12290;&#12414;&#12383;&#12289;&#19990;&#30028;&#12398;&#12356;&#12363;&#12394;&#12427;&#22580;&#25152;&#12395;&#12362;&#12356;&#12390;&#12418;&#12289;&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#31532;&#19977;&#32773;&#12395;&#36009;&#22770;&#12377;&#12427;&#12371;&#12392;&#12399;&#27770;&#12375;&#12390;&#12354;&#12426;&#12414;&#12379;&#12435;&#12290;</span
      >
    </p>
    <p class="c16">
      <span class="c15 c0"
        >&#26410;&#25104;&#24180;&#32773;&#12398;&#20491;&#20154;&#24773;&#22577;&#12398;&#21454;&#38598;&#12392;&#21033;&#29992;</span
      >
    </p>
    <p class="c16">
      <span class="c2 c0"
        >&#24403;&#31038;&#12364;&#12450;&#12513;&#12522;&#12459;&#12391;&#12399; 13
        &#27507;&#26410;&#28288;&#12289;EU &#12391;&#12399; 16
        &#27507;&#26410;&#28288;&#12398;&#26410;&#25104;&#24180;&#32773;&#12363;&#12425;&#25925;&#24847;&#12395;&#24773;&#22577;&#12434;&#21454;&#38598;&#12377;&#12427;&#12371;&#12392;&#12399;&#12354;&#12426;&#12414;&#12379;&#12435;&#12290;&#24403;&#31038;&#12399;&#12450;&#12513;&#12522;&#12459;&#12391;
        13 &#27507;&#26410;&#28288;&#12289;EU &#12391; 16
        &#27507;&#26410;&#28288;&#12398;&#20154;&#12363;&#12425;&#20491;&#20154;&#24773;&#22577;&#12364;&#25552;&#20379;&#12373;&#12428;&#12383;&#12371;&#12392;&#12364;&#21028;&#26126;&#12375;&#12383;&#22580;&#21512;&#12289;&#12381;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#21066;&#38500;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c16">
      <span class="c15 c0">&#12450;&#12463;&#12475;&#12473;&#12392;&#38750;&#35377;&#35582;</span>
    </p>
    <p class="c16">
      <span class="c2 c0"
        >&#12362;&#23458;&#27096;&#12398;&#24773;&#22577;&#12364;&#22793;&#26356;&#12373;&#12428;&#12289;&#30331;&#37682;&#12373;&#12428;&#12390;&#12356;&#12427;&#24773;&#22577;&#12434;&#26356;&#26032;&#12375;&#12383;&#12356;&#22580;&#21512;&#12289;&#20197;&#19979;&#12398;&#36899;&#32097;&#20808;&#24773;&#22577;&#12434;&#20351;&#29992;&#12375;&#12390;&#24403;&#31038;&#12395;&#12372;&#36899;&#32097;&#12367;&#12384;&#12373;&#12356;&#12290;</span
      >
    </p>
    <p class="c16">
      <span class="c2 c0"
        >&#24403;&#31038;&#12363;&#12425;&#12398;&#12510;&#12540;&#12465;&#12486;&#12451;&#12531;&#12464;&#12467;&#12511;&#12517;&#12491;&#12465;&#12540;&#12471;&#12519;&#12531;&#12398;&#21463;&#20449;&#12434;&#24076;&#26395;&#12375;&#12394;&#12356;&#22580;&#21512;&#12289;&#12510;&#12540;&#12465;&#12486;&#12451;&#12531;&#12464;&#12467;&#12511;&#12517;&#12491;&#12465;&#12540;&#12471;&#12519;&#12531;&#12391;&#25552;&#20379;&#12373;&#12428;&#12390;&#12356;&#12427;&#36092;&#35501;&#35299;&#38500;&#25163;&#38918;&#12395;&#24467;&#12358;&#12289;&#12414;&#12383;&#12399;&#20197;&#19979;&#12398;&#12450;&#12489;&#12524;&#12473;&#12395;&#36899;&#32097;&#12375;&#12390;&#25298;&#21542;&#12377;&#12427;&#12371;&#12392;&#12364;&#12391;&#12365;&#12414;&#12377;&#12290;&#30331;&#37682;&#35299;&#38500;&#12399;&#12391;&#12365;&#12427;&#38480;&#12426;&#36805;&#36895;&#12395;&#12289;&#31649;&#36676;&#23550;&#35937;&#27861;&#20196;&#12434;&#36981;&#23432;&#12375;&#12390;&#20966;&#29702;&#12373;&#12428;&#12414;&#12377;&#12364;&#12289;&#30331;&#37682;&#35299;&#38500;&#12364;&#20966;&#29702;&#12373;&#12428;&#12390;&#23436;&#20102;&#12377;&#12427;&#12414;&#12391;&#12289;&#29366;&#27841;&#12395;&#12424;&#12387;&#12390;&#12399;&#12356;&#12367;&#12388;&#12363;&#12398;&#12513;&#12483;&#12475;&#12540;&#12472;&#12364;&#34920;&#31034;&#12373;&#12428;&#12427;&#22580;&#21512;&#12418;&#12354;&#12426;&#12414;&#12377;&#12290;
      </span>
    </p>
    <p class="c16">
      <span class="c2 c0"
        >&#12510;&#12540;&#12465;&#12486;&#12451;&#12531;&#12464;&#12467;&#12511;&#12517;&#12491;&#12465;&#12540;&#12471;&#12519;&#12531;&#12434;&#25298;&#21542;&#12375;&#12383;&#22580;&#21512;&#12418;&#12289;&#12469;&#12452;&#12488;&#12420;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12395;&#38306;&#12377;&#12427;&#37325;&#35201;&#12394;&#26356;&#26032;&#12394;&#12393;&#12434;&#21547;&#12416;&#27880;&#25991;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12395;&#38306;&#12377;&#12427;&#31649;&#29702;&#12513;&#12483;&#12475;&#12540;&#12472;&#12399;&#36865;&#20449;&#12373;&#12428;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c16"><span class="c15 c0">&#12362;&#23458;&#27096;&#12398;&#27177;&#21033;</span></p>
    <p class="c16">
      <span class="c2 c0"
        >&#12362;&#23458;&#27096;&#12364;EEA&#12289;&#33521;&#22269;&#12289;&#12473;&#12452;&#12473;&#12398;&#23621;&#20303;&#32773;&#12391;&#12354;&#12427;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12399;&#35201;&#27714;&#12377;&#12427;&#27177;&#21033;&#12434;&#26377;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <ul class="c6 lst-kix_list_7-0 start">
      <li class="c16 c27 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12364;&#20966;&#29702;&#12373;&#12428;&#12390;&#12356;&#12427;&#12363;&#12393;&#12358;&#12363;&#12434;&#30693;&#12427;&#12371;&#12392;
        </span>
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12408;&#12398;&#12450;&#12463;&#12475;&#12473;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12398;&#32232;&#38598;&#12414;&#12383;&#12399;&#12467;&#12500;&#12540;&#12398;&#36865;&#20184;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12398;&#28040;&#21435;&#12414;&#12383;&#12399;&#21311;&#21517;&#21270;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#20491;&#20154;&#24773;&#22577;&#12398;&#21033;&#29992;&#12434;&#21046;&#38480;&#12377;&#12427;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12399;&#12289;&#12362;&#23458;&#27096;&#12392;&#12398;&#20170;&#24460;&#12398;&#30740;&#31350;&#36899;&#32097;&#12398;&#35215;&#27169;&#12434;&#27770;&#23450;&#12375;&#12289;&#12414;&#12383;&#12399;&#30740;&#31350;&#12408;&#12398;&#21442;&#21152;&#12434;&#25298;&#21542;&#12375;&#12414;&#12377;&#12290;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12364;&#33258;&#21205;&#24847;&#24605;&#27770;&#23450;&#12362;&#12424;&#12403;&#12503;&#12525;&#12501;&#12449;&#12452;&#12522;&#12531;&#12464;&#12539;&#12484;&#12540;&#12523;&#12434;&#20351;&#29992;&#12377;&#12427;&#22580;&#21512;&#12289;&#12381;&#12398;&#26088;&#12434;&#36890;&#30693;&#12377;&#12427;&#12371;&#12392;
        </span>
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#38306;&#36899;&#12377;&#12427;&#12487;&#12540;&#12479;&#20445;&#35703;&#30435;&#30563;&#27231;&#38306;&#12395;&#33510;&#24773;&#12434;&#30003;&#12375;&#31435;&#12390;&#12427;&#12371;&#12392;&#12364;&#12391;&#12365;&#12414;&#12377;&#12290;</span
        >
      </li>
    </ul>
    <p class="c16">
      <span class="c2 c0"
        >EU&#12487;&#12540;&#12479;&#20445;&#35703;&#24403;&#23616;&#12398;&#19968;&#35239;&#12391;&#12377;&#12290;</span
      >
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://edpb.europa.eu/about-edpb/about-edpb/members_en&amp;sa=D&amp;source=editors&amp;ust=1666017343009418&amp;usg=AOvVaw3WFqPdUMTld_xjYtSa0T1E"
          >EEA</a
        ></span
      ><span class="c2 c0">&nbsp;</span>
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://www.edoeb.admin.ch/edoeb/en/home/the-fdpic/links/data-protection---switzerland.html&amp;sa=D&amp;source=editors&amp;ust=1666017343009814&amp;usg=AOvVaw2pFbl6gn194N4Kp2d68vDk"
          >&#12473;&#12452;&#12473;</a
        ></span
      >
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://ico.org.uk/&amp;sa=D&amp;source=editors&amp;ust=1666017343010117&amp;usg=AOvVaw2I_pHX3o7-bYlxQ17WC4jJ"
          >&#12452;&#12462;&#12522;&#12473;</a
        ></span
      >
    </p>
    <p class="c3 c10"><span class="c2 c0"></span></p>
    <p class="c3">
      <span class="c2 c0"
        >&#12459;&#12522;&#12501;&#12457;&#12523;&#12491;&#12450;&#24030;&#12289;&#12467;&#12493;&#12481;&#12459;&#12483;&#12488;&#24030;&#12289;&#12518;&#12479;&#24030;&#12289;&#12467;&#12525;&#12521;&#12489;&#24030;&#12289;&#12496;&#12540;&#12472;&#12491;&#12450;&#24030;&#12289;&#12414;&#12383;&#12399;&#20491;&#20154;&#24773;&#22577;&#20445;&#35703;&#27861;&#12364;&#26045;&#34892;&#12373;&#12428;&#12390;&#12356;&#12427;&#12381;&#12398;&#20182;&#12398;&#31859;&#22269;&#12398;&#24030;&#12391;&#12399;&#12289;&#12362;&#23458;&#27096;&#12399;&#35201;&#27714;&#12377;&#12427;&#27177;&#21033;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c3 c10"><span class="c2 c0"></span></p>
    <ul class="c6 lst-kix_list_8-0 start">
      <li class="c3 c27 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12408;&#12398;&#12450;&#12463;&#12475;&#12473;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12398;&#20462;&#27491;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#24403;&#31038;&#12364;&#12362;&#23458;&#27096;&#12398;&#24773;&#22577;&#12434;&#22770;&#21364;&#12375;&#12383;&#12363;&#12393;&#12358;&#12363;&#12434;&#30693;&#12427;&#27177;&#21033;&#12289;&#12362;&#12424;&#12403;&#20491;&#20154;&#24773;&#22577;&#12398;&#22770;&#21364;&#12434;&#25298;&#21542;&#12377;&#12427;&#27177;&#21033;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0">&#20491;&#20154;&#24773;&#22577;&#12398;&#21066;&#38500;</span>
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#12289;&#29702;&#35299;&#12375;&#12420;&#12377;&#12367;&#12289;&#25216;&#34899;&#30340;&#12395;&#21487;&#33021;&#12394;&#31684;&#22258;&#12391;&#12289;&#27083;&#36896;&#21270;&#12373;&#12428;&#12289;&#19968;&#33324;&#30340;&#12395;&#20351;&#29992;&#12373;&#12428;&#12289;&#27231;&#26800;&#12391;&#35501;&#12415;&#21462;&#12426;&#21487;&#33021;&#12394;&#12501;&#12457;&#12540;&#12510;&#12483;&#12488;&#12391;&#21463;&#38936;&#12377;&#12427;&#27177;&#21033;</span
        >
      </li>
    </ul>
    <p class="c3 c10"><span class="c2 c0"></span></p>
    <p class="c3">
      <span class="c2 c0"
        >&#31859;&#22269;&#12398;&#12487;&#12540;&#12479;&#20445;&#35703;&#24403;&#23616;&#12398;&#19968;&#35239;&#12391;&#12377;&#12290;</span
      >
    </p>
    <p class="c3 c10"><span class="c2 c0"></span></p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://oag.ca.gov/privacy&amp;sa=D&amp;source=editors&amp;ust=1666017343011295&amp;usg=AOvVaw28PwMgkugJeDZXE7SmdBUI"
          >&#12459;&#12522;&#12501;&#12457;&#12523;&#12491;&#12450;&#24030;</a
        ></span
      ><span class="c2 c0">&nbsp;</span>
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://portal.ct.gov/AG/Sections/Privacy/The-Privacy-and-Data-Security-Section&amp;sa=D&amp;source=editors&amp;ust=1666017343011597&amp;usg=AOvVaw1X-lSvljlx1rbIm13wXMUg"
          >&#12467;&#12493;&#12481;&#12459;&#12483;&#12488;&#24030;</a
        ></span
      >
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://attorneygeneral.utah.gov/&amp;sa=D&amp;source=editors&amp;ust=1666017343011902&amp;usg=AOvVaw1MrBD8lh5vsFx_Zb-wasvN"
          >&#12518;&#12479;&#24030;</a
        ></span
      >
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://coag.gov/resources/data-protection-laws/&amp;sa=D&amp;source=editors&amp;ust=1666017343012275&amp;usg=AOvVaw3obiEgyAYUxbrU1Xt8puqY"
          >&#12467;&#12525;&#12521;&#12489;&#24030;</a
        ></span
      >
    </p>
    <p class="c3">
      <span class="c18"
        ><a
          class="c9"
          href="https://www.google.com/url?q=https://www.oag.state.va.us/index.php?option%3Dcom_content%26view%3Darticle%26id%3D335&amp;sa=D&amp;source=editors&amp;ust=1666017343012584&amp;usg=AOvVaw269yiVMXF3Hj3mc0TW4oln"
          >&#12496;&#12540;&#12472;&#12491;&#12450;&#24030;</a
        ></span
      >
    </p>
    <p class="c3 c10"><span class="c2 c0"></span></p>
    <p class="c3">
      <span class="c2 c0"
        >&#20013;&#33775;&#20154;&#27665;&#20849;&#21644;&#22269;&#12395;&#12362;&#20303;&#12414;&#12356;&#12398;&#26041;&#12399;&#12289;&#24403;&#31038;&#12398;&#20013;&#22269;&#35486;&#29256;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12434;&#12372;&#35239;&#12367;&#12384;&#12373;&#12356;&#12290;</span
      >
    </p>
    <p class="c3 c10"><span class="c2 c0"></span></p>
    <p class="c3">
      <span class="c2 c0"
        >&#27177;&#21033;&#12398;&#34892;&#20351;&#12434;&#24076;&#26395;&#12373;&#12428;&#12427;&#22580;&#21512;&#12399;&#12289;privacy@spark-nyc.com
        &#12414;&#12391;&#38651;&#23376;&#12513;&#12540;&#12523;&#12391;&#12372;&#36899;&#32097;&#12367;&#12384;&#12373;&#12356;&#12290;</span
      >
    </p>
    <p class="c16">
      <span class="c15 c0"
        >&#12469;&#12540;&#12489;&#12497;&#12540;&#12486;&#12451;&#12540;&#12398;&#12522;&#12531;&#12463;</span
      >
    </p>
    <p class="c30">
      <span class="c2 c0"
        >Spark
        &#12399;&#12362;&#23458;&#27096;&#12364;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12395;&#12522;&#12531;&#12463;&#12373;&#12428;&#12390;&#12356;&#12427;&#12454;&#12455;&#12502;&#12469;&#12452;&#12488;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12395;&#38306;&#12377;&#12427;&#22768;&#26126;&#12434;&#30906;&#35469;&#12375;&#12289;&#12371;&#12428;&#12425;&#12398;&#12454;&#12455;&#12502;&#12469;&#12452;&#12488;&#12364;&#12393;&#12398;&#12424;&#12358;&#12395;&#24773;&#22577;&#12434;&#21454;&#38598;&#12289;&#20351;&#29992;&#12289;&#20849;&#26377;&#12377;&#12427;&#12363;&#12434;&#20877;&#30906;&#35469;&#12377;&#12427;&#12371;&#12392;&#12434;&#25512;&#22888;&#12375;&#12390;&#12356;&#12414;&#12377;&#12290;Spark
        &#12399;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#20197;&#22806;&#12398;&#12371;&#12428;&#12425;&#12398;&#12454;&#12455;&#12502;&#12469;&#12452;&#12488;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12395;&#38306;&#12377;&#12427;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#22768;&#26126;&#12414;&#12383;&#12399;&#20219;&#24847;&#12398;&#12467;&#12531;&#12486;&#12531;&#12484;&#12395;&#12388;&#12356;&#12390;&#36012;&#20219;&#12434;&#36000;&#12356;&#12414;&#12379;&#12435;&#12290;</span
      >
    </p>
    <p class="c16">
      <span class="c15 c0"
        >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12398;&#12475;&#12461;&#12517;&#12522;&#12486;&#12451;&#12540;</span
      >
    </p>
    <p class="c34">
      <span class="c2 c0"
        >Spark
        &#12399;&#19981;&#27491;&#12394;&#12450;&#12463;&#12475;&#12473;&#12289;&#20351;&#29992;&#12414;&#12383;&#12399;&#38283;&#31034;&#12363;&#12425;&#20491;&#20154;&#24773;&#22577;&#12434;&#20445;&#35703;&#12377;&#12427;&#12383;&#12417;&#12289;&#21512;&#29702;&#30340;&#12394;&#25514;&#32622;&#12434;&#35611;&#12376;&#12414;&#12377;&#12290;&#25563;&#35328;&#12377;&#12428;&#12400;&#12289;&#12452;&#12531;&#12479;&#12540;&#12493;&#12483;&#12488;&#12434;&#20171;&#12375;&#12383;&#12487;&#12540;&#12479;&#36865;&#20449;&#12364;&#35501;&#12415;&#21462;&#12425;&#12428;&#12394;&#12356;&#12371;&#12392;&#12434;
        100&#65285;
        &#12434;&#20445;&#35388;&#12377;&#12427;&#12371;&#12392;&#12399;&#12391;&#12365;&#12363;&#12397;&#12414;&#12377;&#12371;&#12392;&#12434;&#12372;&#29702;&#35299;&#12367;&#12384;&#12373;&#12356;&#12290;&#12375;&#12383;&#12364;&#12387;&#12390;&#12289;&#24403;&#31038;&#12364;&#12362;&#23458;&#27096;&#12395;&#36865;&#20449;&#12377;&#12427;&#24773;&#22577;&#12398;&#12475;&#12461;&#12517;&#12522;&#12486;&#12451;&#12434;&#30906;&#20445;&#12414;&#12383;&#12399;&#20445;&#35388;&#12377;&#12427;&#12371;&#12392;&#12399;&#12391;&#12365;&#12378;&#12289;&#12362;&#23458;&#27096;&#12364;&#24403;&#31038;&#12395;&#36578;&#36865;&#12377;&#12427;&#24773;&#22577;&#12399;&#12377;&#12409;&#12390;&#12362;&#23458;&#27096;&#12398;&#33258;&#24049;&#12398;&#36012;&#20219;&#12395;&#12362;&#12356;&#12390;&#34892;&#12431;&#12428;&#12427;&#12371;&#12392;&#12434;&#29702;&#35299;&#12375;&#12390;&#12356;&#12427;&#12418;&#12398;&#12392;&#12375;&#12414;&#12377;&#12290;
        &nbsp;&#24403;&#31038;&#12364; 1
        &#20214;&#12391;&#12418;&#12475;&#12461;&#12517;&#12522;&#12486;&#12451;&#12471;&#12473;&#12486;&#12512;&#12398;&#36949;&#21453;&#12434;&#24863;&#30693;&#12375;&#12383;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12395;&#38651;&#23376;&#30340;&#12395;&#36890;&#30693;&#12375;&#12424;&#12358;&#12392;&#12377;&#12427;&#12371;&#12392;&#12391;&#12289;&#12362;&#23458;&#27096;&#12364;&#36969;&#20999;&#12394;&#20445;&#35703;&#25514;&#32622;&#12434;&#35611;&#12376;&#12425;&#12428;&#12427;&#12424;&#12358;&#12395;&#12377;&#12427;&#22580;&#21512;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#12469;&#12452;&#12488;&#12420;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#20351;&#29992;&#12377;&#12427;&#12363;&#12289;&#20491;&#20154;&#24773;&#22577;&#12434;&#25552;&#20379;&#12377;&#12427;&#12371;&#12392;&#12395;&#12424;&#12426;&#12289;&#12362;&#23458;&#27096;&#12399;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12398;&#20351;&#29992;&#12395;&#38306;&#36899;&#12377;&#12427;&#12475;&#12461;&#12517;&#12522;&#12486;&#12451;&#12289;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12362;&#12424;&#12403;&#31649;&#29702;&#19978;&#12398;&#21839;&#38988;&#12395;&#12388;&#12356;&#12390;&#12289;&#24403;&#31038;&#12364;&#12371;&#12428;&#12425;&#12434;&#38651;&#23376;&#30340;&#12395;&#36890;&#20449;&#12391;&#12365;&#12427;&#12371;&#12392;&#12395;&#21516;&#24847;&#12375;&#12390;&#12356;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;1
        &#20214;&#12391;&#12418;&#12475;&#12461;&#12517;&#12522;&#12486;&#12451;&#36949;&#21453;&#12364;&#30330;&#29983;&#12377;&#12427;&#22580;&#21512;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#20171;&#12375;&#12390;
        1
        &#22238;&#12398;&#36890;&#30693;&#12434;&#25237;&#31295;&#12377;&#12427;&#22580;&#21512;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#12414;&#12383;&#12289;&#12371;&#12398;&#12424;&#12358;&#12394;&#29366;&#27841;&#12391;&#24403;&#31038;&#12399;&#25552;&#20379;&#12373;&#12428;&#12383;&#12513;&#12540;&#12523;&#12450;&#12489;&#12524;&#12473;&#12395;
        1
        &#20214;&#12398;&#12513;&#12540;&#12523;&#12434;&#36865;&#20449;&#12377;&#12427;&#22580;&#21512;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#12362;&#20303;&#12414;&#12356;&#12398;&#22320;&#22495;&#12395;&#12424;&#12387;&#12390;&#12399;&#12289;&#12475;&#12461;&#12517;&#12522;&#12486;&#12451;&#36949;&#21453;&#12398;&#36890;&#30693;&#12434;&#26360;&#38754;&#12391;&#21463;&#12369;&#21462;&#12427;&#27861;&#30340;&#27177;&#21033;&#12364;&#12354;&#12427;&#22580;&#21512;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c34"><span class="c15 c0">&#12487;&#12540;&#12479;&#20445;&#25345;</span></p>
    <p class="c34">
      <span class="c2 c0"
        >&#12424;&#12426;&#38263;&#12356;&#20445;&#25345;&#26399;&#38291;&#12364;&#12289;&#27861;&#24459;&#12395;&#12424;&#12426;&#35201;&#27714;&#12414;&#12383;&#12399;&#35377;&#21487;&#12373;&#12428;&#12390;&#12356;&#12427;&#22580;&#21512;&#12434;&#38500;&#12365;&#12289;&#24403;&#31038;&#12399;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12391;&#27010;&#35500;&#12373;&#12428;&#12390;&#12356;&#12427;&#30446;&#30340;&#12434;&#36948;&#25104;&#12377;&#12427;&#12383;&#12417;&#12395;&#24517;&#35201;&#12394;&#26399;&#38291;&#12395;&#12431;&#12383;&#12426;&#12289;&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#20445;&#25345;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c10 c34"><span class="c2 c0"></span></p>
    <p class="c19">
      <span class="c15 c0"
        >&#22269;&#38555;&#38291;&#12391;&#12398;&#12487;&#12540;&#12479;&#36578;&#36865;</span
      >
    </p>
    <p class="c19">
      <span class="c2 c0"
        >&#12362;&#23458;&#27096;&#12364;&#24403;&#31038;&#12395;&#24773;&#22577;&#12434;&#25552;&#20379;&#12377;&#12427;&#12371;&#12392;&#12434;&#36984;&#25246;&#12375;&#12383;&#22580;&#21512;&#12289;&#24403;&#31038;&#12399;&#12381;&#12398;&#24773;&#22577;&#12434;&#24403;&#31038;&#12398;&#38306;&#36899;&#20250;&#31038;&#12362;&#12424;&#12403;&#23376;&#20250;&#31038;&#12414;&#12383;&#12399;&#12381;&#12398;&#20182;&#12398;&#12469;&#12540;&#12489;&#12497;&#12540;&#12486;&#12451;&#12540;&#12395;&#12289;&#22269;&#22659;&#12539;&#22320;&#22495;&#12398;&#22659;&#30028;&#12434;&#36234;&#12360;&#12289;&#12362;&#23458;&#27096;&#12398;&#22269;&#12539;&#22320;&#22495;&#12418;&#12375;&#12367;&#12399;&#31649;&#36676;&#21306;&#22495;&#12363;&#12425;&#19990;&#30028;&#20013;&#12398;&#20182;&#12398;&#22269;&#12539;&#22320;&#22495;&#12414;&#12383;&#12399;&#31649;&#36676;&#21306;&#22495;&#12395;&#36578;&#36865;&#12377;&#12427;&#22580;&#21512;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#12450;&#12513;&#12522;&#12459;&#12398;&#27861;&#24459;&#12392;&#12399;&#30064;&#12394;&#12427;&#12487;&#12540;&#12479;&#12398;&#21454;&#38598;&#12392;&#20351;&#29992;&#12434;&#31649;&#29702;&#12377;&#12427;&#27861;&#24459;&#12364;&#12354;&#12427;
        EU
        &#12414;&#12383;&#12399;&#12381;&#12398;&#20182;&#12398;&#22320;&#22495;&#12363;&#12425;&#12450;&#12463;&#12475;&#12473;&#12375;&#12390;&#12356;&#12427;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12399;&#23621;&#20303;&#22269;&#12539;&#22320;&#22495;&#12392;&#21516;&#12376;&#12487;&#12540;&#12479;&#20445;&#35703;&#27861;&#12434;&#25345;&#12383;&#12394;&#12356;&#21487;&#33021;&#24615;&#12398;&#12354;&#12427;&#12450;&#12513;&#12522;&#12459;&#12362;&#12424;&#12403;&#12381;&#12398;&#20182;&#12398;&#31649;&#36676;&#21306;&#22495;&#12395;&#20491;&#20154;&#24773;&#22577;&#12434;&#36578;&#36865;&#12377;&#12427;&#12371;&#12392;&#12394;&#12427;&#12371;&#12392;&#12395;&#12372;&#30041;&#24847;&#12367;&#12384;&#12373;&#12356;&#12290;&#12362;&#23458;&#27096;&#12399;&#20491;&#20154;&#24773;&#22577;&#12434;&#25552;&#20379;&#12377;&#12427;&#12371;&#12392;&#12395;&#12424;&#12426;&#12289;&#27425;&#12434;&#29702;&#35299;&#12375;&#12390;&#12356;&#12427;&#12371;&#12392;&#12434;&#26159;&#35469;&#12375;&#12390;&#12356;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;</span
      >
    </p>
    <ul class="c6 lst-kix_list_6-0 start">
      <li class="c19 c27 li-bullet-0">
        <span class="c2 c0"
          >&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12399;&#12289;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12395;&#24467;&#12356;&#12289;&#19978;&#35352;&#12391;&#29305;&#23450;&#12373;&#12428;&#12383;&#29992;&#36884;&#12395;&#20351;&#29992;&#12373;&#12428;&#12427;&#12371;&#12392;
          &#12392;&#32626;&#21517;&#12375;&#12383;&#12487;&#12540;&#12479;&#20445;&#35703;&#22865;&#32004;&#12290;</span
        >
      </li>
      <li class="c20 li-bullet-0">
        <span class="c2 c0"
          >&#19978;&#35352;&#12398;&#31649;&#36676;&#23550;&#35937;&#27861;&#20196;&#12395;&#24467;&#12356;&#12289;&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12364;&#12450;&#12513;&#12522;&#12459;&#12362;&#12424;&#12403;&#12381;&#12398;&#20182;&#12398;&#27861;&#22495;&#12395;&#36578;&#36865;&#12373;&#12428;&#12427;&#22580;&#21512;&#12418;&#12354;&#12427;&#12371;&#12392;&#12290;&#24403;&#31038;&#12398;&#29694;&#22312;&#12398;&#12469;&#12502;&#12503;&#12525;&#12475;&#12483;&#12469;&#12540;&#12392;&#12487;&#12540;&#12479;&#36578;&#36865;&#12395;&#38306;&#12377;&#12427;&#35036;&#36275;&#25514;&#32622;&#12398;&#19968;&#35239;&#12399;&#12289;&#12371;&#12385;&#12425;&#12391;&#12372;&#30906;&#35469;&#12356;&#12383;&#12384;&#12369;&#12414;&#12377;&#12290;</span
        >
      </li>
    </ul>
    <p class="c19"><span class="c15 c0">&#35698;&#28193;&#26465;&#38917;</span></p>
    <p class="c19">
      <span class="c2 c0"
        >&#24403;&#31038;&#36039;&#29987;&#12398;&#20840;&#37096;&#12418;&#12375;&#12367;&#12399;&#19968;&#37096;&#12364;&#21029;&#12398;&#24403;&#20107;&#32773;&#12395;&#12424;&#12426;&#22770;&#21364;&#12414;&#12383;&#12399;&#21462;&#24471;&#12373;&#12428;&#12383;&#22580;&#21512;&#12289;&#12414;&#12383;&#12399;&#21512;&#20341;&#12289;&#36023;&#21454;&#12289;&#22770;&#21364;&#12289;&#30772;&#29987;&#12289;&#12362;&#12424;&#12403;&#24403;&#31038;&#36039;&#29987;&#12398;&#20840;&#37096;&#12418;&#12375;&#12367;&#12399;&#19968;&#37096;&#12398;&#22770;&#21364;&#12434;&#21547;&#12416;&#12364;&#12371;&#12428;&#12425;&#12395;&#38480;&#23450;&#12373;&#12428;&#12394;&#12356;&#12289;&#20219;&#24847;&#12398;&#30452;&#25509;&#30340;&#12418;&#12375;&#12367;&#12399;&#38291;&#25509;&#30340;&#12394;&#20877;&#32232;&#25104;&#12398;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12399;&#12289;&#12371;&#12398;&#12424;&#12358;&#12394;&#21462;&#24341;&#12398;&#23436;&#20102;&#24460;&#12362;&#12424;&#12403;/&#12418;&#12375;&#12367;&#12399;&#35698;&#28193;&#24453;&#27231;&#20013;&#12398;&#35413;&#20385;&#12503;&#12525;&#12475;&#12473;&#12398;&#38555;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12414;&#12383;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#20171;&#12375;&#12390;&#21454;&#38598;&#12373;&#12428;&#12383;&#24403;&#35442;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#35698;&#28193;&#12377;&#12427;&#27177;&#21033;&#12434;&#24403;&#31038;&#12395;&#31227;&#35698;&#12375;&#12390;&#12356;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;&#12371;&#12398;&#12424;&#12358;&#12394;1&#20214;&#12398;&#26696;&#20214;&#12391;&#35698;&#28193;&#12373;&#12428;&#12383;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12398;&#24773;&#22577;&#12399;&#12289;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12398;&#23550;&#35937;&#12392;&#12375;&#12390;&#20445;&#25345;&#12373;&#12428;&#12427;&#12363;&#12289;&#12414;&#12383;&#12399;&#26368;&#20302;&#38480;&#12391;&#12418;&#12289;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12392;&#21516;&#27700;&#28310;&#12391;&#12362;&#23458;&#27096;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12364;&#20445;&#35703;&#12373;&#12428;&#12427;&#12363;&#12289;&#12377;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c19">
      <span class="c15 c0"
        >&#32027;&#20105;&#35299;&#27770;&#12392;&#20210;&#35009;&#12398;&#21512;&#24847;</span
      >
    </p>
    <p class="c19">
      <span class="c2 c0"
        >&#27861;&#24459;&#12391;&#31105;&#27490;&#12373;&#12428;&#12390;&#12356;&#12427;&#29366;&#27841;&#12362;&#12424;&#12403;&#31684;&#22258;&#12434;&#38500;&#12365;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12418;&#12375;&#12367;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12434;&#20351;&#29992;&#12377;&#12427;&#12371;&#12392;&#12395;&#12424;&#12426;&#12289;&#12362;&#23458;&#27096;&#12392;
        Spark
        &#12399;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;/&#12418;&#12375;&#12367;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12398;&#21033;&#29992;&#12289;&#12414;&#12383;&#12399;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12418;&#12375;&#12367;&#12399;&#12381;&#12398;&#19968;&#37096;&#12398;&#36949;&#21453;&#12289;&#26045;&#34892;&#12289;&#35299;&#37320;&#12289;&#12414;&#12383;&#12399;&#26377;&#21177;&#24615;&#12395;&#36215;&#22240;&#12418;&#12375;&#12367;&#12399;&#12381;&#12428;&#12395;&#38306;&#36899;&#12377;&#12427;&#12289;&#35542;&#20105;&#12289;&#20027;&#24373;&#12289;&#34892;&#21205;&#65288;&#38598;&#32004;&#30340;&#12395;&#12300;&#32027;&#20105;&#12301;&#65289;&#12364;&#23384;&#22312;&#12375;&#12390;&#12356;&#12427;&#22580;&#21512;&#12289;&#20001;&#24403;&#20107;&#32773;&#12399;&#12414;&#12378;&#12289;&#32027;&#20105;&#12398;&#20107;&#23455;&#12392;&#29366;&#27841;&#12434;&#35352;&#36848;&#12375;&#12383;&#26360;&#38754;&#12395;&#12424;&#12427;&#36890;&#30693;&#12434;&#30456;&#25163;&#26041;&#12395;&#25552;&#20379;&#12375;&#12289;&#21463;&#38936;&#12377;&#12427;&#24403;&#20107;&#32773;&#12395;&#24403;&#35442;&#12398;&#32027;&#20105;&#12395;&#23550;&#24540;&#12418;&#12375;&#12367;&#12399;&#35299;&#27770;&#12377;&#12427;&#12383;&#12417;&#12398;
        30
        &#26085;&#38291;&#12398;&#29494;&#20104;&#12434;&#19982;&#12360;&#12427;&#12371;&#12392;&#12395;&#12424;&#12426;&#12289;&#12381;&#12398;&#12424;&#12358;&#12394;&#32027;&#20105;&#12434;&#35299;&#27770;&#12377;&#12427;&#12383;&#12417;&#12395;&#35488;&#23455;&#12395;&#21162;&#21147;&#12377;&#12427;&#12371;&#12392;&#12395;&#21516;&#24847;&#12375;&#12390;&#12356;&#12427;&#12418;&#12398;&#12392;&#12377;&#12427;&#12290;&#36890;&#30693;&#12399;&#27425;&#12395;&#36865;&#20184;&#12375;&#12390;&#12367;&#12384;&#12373;&#12356;&#12290;</span
      >
    </p>
    <p class="c1"><span class="c2 c0">Spark Ideas, LLC</span></p>
    <p class="c28"><span class="c2 c0">1328 Ridge Road</span></p>
    <p class="c26"><span class="c2 c0">Syosset, New York 11791</span></p>
    <p class="c19">
      <span class="c0"
        >&#12362;&#23458;&#27096;&#12392; Spark
        &#12399;&#12393;&#12385;&#12425;&#12418;&#12289;&#12371;&#12398;&#32027;&#20105;&#35299;&#27770;&#25163;&#38918;&#12364;&#12289;&#35380;&#35359;&#12434;&#38283;&#22987;&#12375;&#12383;&#12426;&#12289;&#30456;&#25163;&#26041;&#12395;&#23550;&#12375;&#12390;&#35531;&#27714;&#12434;&#25552;&#20986;&#12375;&#12383;&#12426;&#12377;&#12427;&#21069;&#12395;&#28288;&#12383;&#12377;&#24517;&#35201;&#12398;&#12354;&#12427;
        1
        &#20214;&#12398;&#21069;&#25552;&#26465;&#20214;&#12391;&#12354;&#12427;&#12371;&#12392;&#12395;&#21516;&#24847;&#12375;&#12390;&#12356;&#12427;&#12418;&#12398;&#12392;&#12375;&#12414;&#12377;&#12290;</span
      ><span class="c32 c0"
        >&#20219;&#24847;&#12398;&#32027;&#20105;&#12364;&#19978;&#35352;&#12398;&#32027;&#20105;&#35299;&#27770;&#25163;&#38918;&#12391;&#35299;&#27770;&#12391;&#12365;&#12394;&#12356;&#22580;&#21512;&#12289;&#12362;&#23458;&#27096;&#12399;&#12381;&#12398;&#12424;&#12358;&#12394;&#32027;&#20105;&#12398;&#21807;&#19968;&#12363;&#12388;&#25490;&#20182;&#30340;&#12394;&#31649;&#36676;&#27177;&#12364;&#12289;&#20491;&#21029;&#12398;&#35380;&#35359;&#12395;&#22522;&#12389;&#12365;&#25304;&#26463;&#21147;&#12434;&#26377;&#12377;&#12427;&#20210;&#35009;&#12395;&#12424;&#12426;&#27770;&#23450;&#12373;&#12428;&#12427;&#12371;&#12392;&#12395;&#21516;&#24847;&#12375;&#12390;&#12356;&#12427;&#12418;&#12398;&#12392;&#12375;&#12414;&#12377;&#12290;&#20491;&#20154;&#21336;&#20301;&#12398;&#20210;&#35009;&#12392;&#12399;&#12362;&#23458;&#27096;&#12364;&#35009;&#21028;&#23448;&#12414;&#12383;&#12399;&#38506;&#23529;&#21729;&#12398;&#30003;&#31435;&#12434;&#27770;&#23450;&#12377;&#12427;&#27177;&#21033;&#12434;&#25345;&#12383;&#12378;&#12289;&#25918;&#26820;&#12377;&#12427;&#12371;&#12392;&#12434;&#24847;&#21619;&#12375;&#12289;&#38598;&#22243;&#12289;&#22243;&#20307;&#12414;&#12383;&#12399;&#20195;&#34920;&#30340;&#12394;&#33021;&#21147;&#12391;&#32154;&#34892;&#12377;&#12427;&#12371;&#12392;&#12364;&#12391;&#12365;&#12394;&#12356;&#12371;&#12392;&#12434;&#24847;&#21619;&#12375;&#12414;&#12377;&#12290;</span
      ><span class="c2 c0"
        >&#38283;&#31034;&#25163;&#32154;&#12362;&#12424;&#12403;&#19978;&#35380;&#27177;&#12434;&#21547;&#12416;&#12289;&#12362;&#23458;&#27096;&#12362;&#12424;&#12403;&#24403;&#31038;&#12364;&#12289;&#12371;&#12428;&#20197;&#22806;&#12391;&#12289;&#27861;&#24311;&#12391;&#25152;&#26377;&#12377;&#12427;&#12381;&#12398;&#20182;&#12398;&#35576;&#27177;&#21033;&#12399;&#20210;&#35009;&#12395;&#12362;&#12356;&#12390;&#21033;&#29992;&#19981;&#21487;&#12392;&#12394;&#12427;&#12363;&#12289;&#12414;&#12383;&#12399;&#12424;&#12426;&#21046;&#38480;&#12373;&#12428;&#12427;&#12363;&#12289;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;&#12381;&#12398;&#12424;&#12358;&#12394;&#12377;&#12409;&#12390;&#12398;&#32027;&#20105;&#12399;&#24403;&#35442;&#35215;&#21063;&#12395;&#22522;&#12389;&#12367;&#25304;&#26463;&#21147;&#12398;&#12354;&#12427;&#20210;&#35009;&#12398;&#12383;&#12417;&#12395;
        JAMS&#65288;www.jamsadr.com&#65289;&#12395;&#29420;&#21344;&#30340;&#12395;&#25552;&#20986;&#12373;&#12428;&#12289;&#12381;&#12398;&#24460;&#12289;1
        &#20154;&#12398;&#20210;&#35009;&#32773;&#12364;&#20001;&#24403;&#20107;&#32773;&#12395;&#12424;&#12387;&#12390;&#30456;&#20114;&#12395;&#21512;&#24847;&#12373;&#12428;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;&#20210;&#35009;&#32773;&#12364;&#12289;&#12362;&#23458;&#27096;&#12398;&#30330;&#35696;&#12395;&#12424;&#12427;&#12363;&#12289;&#12414;&#12383;&#12399;&#24403;&#31038;&#12398;&#30330;&#35696;&#12395;&#12424;&#12427;&#12363;&#12289;&#12398;&#35201;&#35531;&#12434;&#21463;&#12369;&#12390;&#12289;1
        &#22238;&#12398;&#26412;&#20154;&#20986;&#38957;&#12398;&#32884;&#32862;&#20250;&#12364;&#36969;&#20999;&#12391;&#12354;&#12427;&#12392;&#21028;&#26029;&#12375;&#12394;&#12356;&#38480;&#12426;&#12289;&#20491;&#20154;&#12364;&#20986;&#38957;&#12377;&#12427;&#12384;&#12369;&#12391;&#12399;&#12394;&#12367;&#12289;&#38651;&#35441;&#20250;&#35696;&#12414;&#12383;&#12399;&#12499;&#12487;&#12458;&#20250;&#35696;&#12395;&#12424;&#12426;&#12289;&#20309;&#12425;&#12363;&#12398;&#32884;&#32862;&#20250;&#12434;&#23455;&#26045;&#12377;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;&#20219;&#24847;&#12398;&#26412;&#20154;&#20986;&#38957;&#12399;&#12289;&#24403;&#20107;&#32773;&#21508;&#33258;&#12398;&#31227;&#21205;&#12398;&#23455;&#29694;&#24615;&#12362;&#12424;&#12403;&#12381;&#12398;&#20182;&#12398;&#38306;&#36899;&#12377;&#12427;&#29366;&#27841;&#12434;&#21313;&#20998;&#12395;&#32771;&#24942;&#12377;&#12427;&#12371;&#12392;&#12395;&#12424;&#12426;&#12289;&#20001;&#24403;&#20107;&#32773;&#12395;&#12392;&#12387;&#12390;&#21512;&#29702;&#30340;&#12395;&#20415;&#21033;&#12394;
        1
        &#12363;&#25152;&#12398;&#22580;&#25152;&#12395;&#12390;&#38283;&#20652;&#12373;&#12428;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;&#24403;&#20107;&#32773;&#12364;
        1
        &#12363;&#25152;&#12398;&#22580;&#25152;&#12395;&#38306;&#12375;&#12390;&#21512;&#24847;&#12377;&#12427;&#12371;&#12392;&#12364;&#12391;&#12365;&#12394;&#12356;&#22580;&#21512;&#12289;&#12381;&#12398;&#12424;&#12358;&#12394;&#27770;&#23450;&#12399;JAMS&#12395;&#12424;&#12427;&#12363;&#12414;&#12383;&#12399;&#24403;&#35442;&#20210;&#35009;&#20154;&#12395;&#12424;&#12426;&#23455;&#34892;&#12373;&#12428;&#12427;&#12371;&#12392;&#12392;&#12394;&#12426;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c19">
      <span class="c2 c0"
        >&#20219;&#24847;&#12398;&#36899;&#37030;&#12289;&#24030;&#12289;&#12414;&#12383;&#12399;&#22320;&#26041;&#35009;&#21028;&#25152;&#12418;&#12375;&#12367;&#12399;&#20195;&#29702;&#27231;&#38306;&#12364;&#12391;&#12399;&#12394;&#12367;&#12289;&#24403;&#35442;&#20210;&#35009;&#32773;&#12371;&#12381;&#12364;&#12289;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12398;&#20840;&#37096;&#12418;&#12375;&#12367;&#12399;&#19968;&#37096;&#12434;&#28961;&#21177;&#12414;&#12383;&#12399;&#28961;&#21177;&#21270;&#12391;&#12365;&#12427;&#12392;&#12356;&#12358;&#20219;&#24847;&#12398;&#20027;&#24373;&#12434;&#21547;&#12417;&#12289;&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12398;&#35299;&#37320;&#12289;&#36969;&#29992;&#24615;&#12289;&#24375;&#21046;&#21147;&#12289;&#12414;&#12383;&#12399;&#24418;&#25104;&#12395;&#38306;&#36899;&#12375;&#12390;&#30330;&#29983;&#12377;&#12427;&#32027;&#20105;&#12434;&#35299;&#27770;&#12377;&#12427;&#12383;&#12417;&#12398;&#29420;&#21344;&#30340;&#12394;&#27177;&#38480;&#12434;&#26377;&#12377;&#12427;&#12371;&#12392;&#12392;&#12377;&#12427;&#12290;</span
      >
    </p>
    <p class="c19"><span class="c15 c0">&#28310;&#25312;&#27861;&#26465;&#38917;</span></p>
    <p class="c19">
      <span class="c2 c0"
        >&#26412;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12399;&#27861;&#12398;&#21407;&#21063;&#12395;&#12388;&#12356;&#12390;&#12398;&#12354;&#12425;&#12422;&#12427;&#25269;&#35302;&#12395;&#21177;&#21147;&#12434;&#19982;&#12360;&#12427;&#12371;&#12392;&#12394;&#12367;&#12289;&#65288;&#31859;&#22269;&#65289;&#12491;&#12517;&#12540;&#12520;&#12540;&#12463;&#24030;&#12398;&#27861;&#24459;&#12395;&#12390;&#36215;&#33609;&#12373;&#12428;&#12289;&#12371;&#12428;&#12434;&#36981;&#23432;&#12375;&#35299;&#37320;&#12373;&#12428;&#12427;&#12418;&#12398;&#12392;&#12377;&#12427;&#12290;&#24403;&#20107;&#32773;&#12399;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12364;&#24030;&#65288;&#37117;&#36947;&#24220;&#30476;&#12539;&#34892;&#25919;&#21306;&#20998;&#65289;&#38291;&#12391;&#12398;&#21830;&#21462;&#24341;&#12364;&#38306;&#19982;&#12375;&#12390;&#12356;&#12427;&#21462;&#24341;&#12391;&#12354;&#12427;&#12371;&#12392;&#12434;&#35469;&#35672;&#12375;&#12390;&#12356;&#12427;&#12371;&#12392;&#12392;&#12377;&#12427;&#12290;&#31649;&#36676;&#23550;&#35937;&#12392;&#12394;&#12427;&#23455;&#20307;&#27861;&#12395;&#38306;&#12377;&#12427;&#21069;&#38917;&#12398;&#35215;&#23450;&#12395;&#12363;&#12363;&#12431;&#12425;&#12378;&#12289;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12398;&#26465;&#38917;&#12434;&#36981;&#23432;&#12375;&#12390;&#22519;&#34892;&#12373;&#12428;&#12427;&#20210;&#35009;&#12395;&#12399;&#36899;&#37030;&#20210;&#35009;&#27861;&#65288;9
        U.S.C.&sect;&sect;1-16&#65289;&#12364;&#36969;&#29992;&#12373;&#12428;&#12427;&#12418;&#12398;&#12392;&#12377;&#12427;&#12290;</span
      >
    </p>
    <p class="c19">
      <span class="c15 c0"
        >&#12362;&#23458;&#27096;&#12398;&#12459;&#12522;&#12501;&#12457;&#12523;&#12491;&#12450;&#24030;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#27177;&#21033;&#27861;&#26465;&#38917;&#12362;&#12424;&#12403;&#24403;&#31038;&#12398;&#12300;&#12488;&#12521;&#12483;&#12461;&#12531;&#12464;&#25298;&#21542;&#12301;&#24847;&#24605;&#34920;&#31034;&#12395;&#23550;&#12377;&#12427;&#23550;&#24540;&#26041;&#27861;</span
      >
    </p>
    <p class="c19">
      <span class="c2 c0"
        >&#12459;&#12522;&#12501;&#12457;&#12523;&#12491;&#12450;&#24030;&#27665;&#27861;&#31532; 1798.83
        &#26465;&#12391;&#12399;&#12289;&#12459;&#12522;&#12501;&#12457;&#12523;&#12491;&#12450;&#24030;&#23621;&#20303;&#32773;&#12391;&#12354;&#12427;&#12469;&#12452;&#12488;&#35370;&#21839;&#32773;&#12362;&#12424;&#12403;/&#12418;&#12375;&#12367;&#12399;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#21033;&#29992;&#32773;&#12364;&#12289;&#12480;&#12452;&#12524;&#12463;&#12488;&#12510;&#12540;&#12465;&#12486;&#12451;&#12531;&#12464;&#30446;&#30340;&#12391;&#12469;&#12540;&#12489;&#12497;&#12540;&#12486;&#12451;&#12540;&#12395;&#23550;&#12375;&#12390;&#20491;&#20154;&#24773;&#22577;&#12395;&#12388;&#12356;&#12390;&#12398;&#24403;&#31038;&#12398;&#38283;&#31034;&#12395;&#38306;&#12375;&#12390;&#29305;&#23450;&#24773;&#22577;&#12434;&#35531;&#27714;&#12377;&#12427;&#12371;&#12392;&#12364;&#35377;&#21487;&#12373;&#12428;&#12390;&#12356;&#12414;&#12377;&#12290;&#12480;&#12452;&#12524;&#12463;&#12488;&#12510;&#12540;&#12465;&#12486;&#12451;&#12531;&#12464;&#12434;&#30446;&#30340;&#12392;&#12375;&#12390;&#12289;&#24403;&#31038;&#12364;&#12362;&#23458;&#27096;&#12398;&#20491;&#20154;&#24773;&#22577;&#12434;&#12469;&#12540;&#12489;&#12497;&#12540;&#12486;&#12451;&#12540;&#12392;&#20849;&#26377;&#12377;&#12427;&#12371;&#12392;&#12399;&#12354;&#12426;&#12414;&#12379;&#12435;&#12290;</span
      >
    </p>
    <p class="c19">
      <span class="c2 c0"
        >&#29694;&#26178;&#28857;&#12391;&#12289;&#24403;&#31038;&#12398;&#12469;&#12452;&#12488;&#12399;&#12300;&#12488;&#12521;&#12483;&#12461;&#12531;&#12464;&#25298;&#21542;&#12301;&#25351;&#31034;&#12434;&#21547;&#12416;&#21487;&#33021;&#24615;&#12398;&#12354;&#12427;&#36861;&#36321;&#12513;&#12459;&#12491;&#12474;&#12512;&#12434;&#21547;&#12416;&#22580;&#21512;&#12364;&#12354;&#12427;&#12289;&#33258;&#21205;&#21270;&#12373;&#12428;&#12383;&#12502;&#12521;&#12454;&#12470;&#12540;&#36890;&#30693;&#20449;&#21495;&#12434;&#35469;&#35672;&#12375;&#12414;&#12379;&#12435;&#12290;</span
      >
    </p>
    <p class="c19"><span class="c15 c0">&#36899;&#32097;&#20808;</span></p>
    <p class="c10 c13"><span class="c2 c0"></span></p>
    <p class="c13">
      <span class="c2 c0"
        >Spark
        &#12399;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12362;&#12424;&#12403;&#24403;&#31038;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#24931;&#34892;&#12395;&#38306;&#12377;&#12427;&#36074;&#21839;&#12420;&#12467;&#12513;&#12531;&#12488;&#12434;&#27475;&#36814;&#12375;&#12414;&#12377;&#12290;&#24403;&#31038;&#12408;&#12398;&#12362;&#21839;&#12356;&#21512;&#12431;&#12379;&#12399;&#27425;&#23451;&#12390;&#12395;&#12362;&#39000;&#12356;&#12356;&#12383;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
    <p class="c1"><span class="c2 c0">Spark Ideas, LLC</span></p>
    <p class="c28"><span class="c2 c0">1328 Ridge Road</span></p>
    <p class="c26"><span class="c2 c0">Syosset, New York 11791 </span></p>
    <p class="c26"><span class="c2 c0">&#12450;&#12513;&#12522;&#12459;&#21512;&#34886;&#22269;</span></p>
    <p class="c10 c26"><span class="c0 c2"></span></p>
    <p class="c36">
      <span class="c2 c0">&#12513;&#12540;&#12523;&#12450;&#12489;&#12524;&#12473;&#65306;</span>
    </p>
    <p class="c36"><span class="c18">privacy@spark-nyc.com</span><span class="c2 c0">&nbsp; </span></p>
    <p class="c1">
      <span class="c2 c0"
        >&#38651;&#35441;&#30058;&#21495;&#65288;&#31859;&#22269;&#20869;&#65289;&#65306;</span
      >
    </p>
    <p class="c35"><span class="c2 c0">(917) 991-0477</span></p>
    <p class="c19">
      <span class="c15 c0"
        >&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12408;&#12398;&#22793;&#26356;</span
      >
    </p>
    <p class="c10 c37"><span class="c15 c0"></span></p>
    <p class="c37">
      <span class="c2 c0"
        >Spark
        &#12399;&#20225;&#26989;&#12392;&#39015;&#23458;&#12398;&#12501;&#12451;&#12540;&#12489;&#12496;&#12483;&#12463;&#12434;&#21453;&#26144;&#12377;&#12427;&#12383;&#12417;&#12289;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12434;&#22793;&#26356;&#12377;&#12427;&#12371;&#12392;&#12364;&#12354;&#12426;&#12414;&#12377;&#12290;&#12381;&#12398;&#38555;&#12395;&#12399;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12398;&#20882;&#38957;&#12395;&#12354;&#12427;&#12300;&#30330;&#21177;&#26085;&#12301;&#12418;&#25913;&#35330;&#12375;&#12414;&#12377;&#12290;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12395;&#22823;&#12365;&#12394;&#22793;&#26356;&#12364;&#21152;&#12360;&#12425;&#12428;&#12383;&#22580;&#21512;&#12289;&#12469;&#12452;&#12488;&#12362;&#12424;&#12403;&#12514;&#12496;&#12452;&#12523;&#12450;&#12503;&#12522;&#12395;&#30446;&#31435;&#12388;&#36890;&#30693;&#12434;&#37197;&#32622;&#12375;&#12390;&#36890;&#30693;&#12375;&#12414;&#12377;&#12290;Spark
        &#12364;&#12362;&#23458;&#27096;&#12398;&#24773;&#22577;&#12434;&#12393;&#12398;&#12424;&#12358;&#12395;&#20966;&#29702;&#12375;&#12390;&#12356;&#12427;&#12363;&#12434;&#30693;&#12427;&#12383;&#12417;&#12289;&#12371;&#12398;&#12503;&#12521;&#12452;&#12496;&#12471;&#12540;&#12509;&#12522;&#12471;&#12540;&#12434;&#23450;&#26399;&#30340;&#12395;&#30906;&#35469;&#12377;&#12427;&#12371;&#12392;&#12434;&#25512;&#22888;&#12375;&#12414;&#12377;&#12290;</span
      >
    </p>
  </LLWordTextContainer>
</template>

<script>
import LLWordTextContainer from '@/components/common/LLWordTextContainer'
export default {
  name: 'PrivacyPolicyJA',
  components: { LLWordTextContainer }
}
</script>

<style lang="scss" scoped>
.PrivacyPolicyJA {
  ul.lst-kix_list_1-0 {
    list-style-type: none;
  }
  .lst-kix_list_3-0 > li:before {
    content: '\0025cf  ';
  }
  ul.lst-kix_list_5-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_5-8 {
    list-style-type: none;
  }
  .lst-kix_list_3-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_3-2 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_5-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_5-6 {
    list-style-type: none;
  }
  .lst-kix_list_8-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_8-2 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_1-3 {
    list-style-type: none;
  }
  .lst-kix_list_3-5 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_5-0 {
    list-style-type: none;
  }
  ul.lst-kix_list_1-4 {
    list-style-type: none;
  }
  ul.lst-kix_list_1-1 {
    list-style-type: none;
  }
  .lst-kix_list_3-4 > li:before {
    content: 'o  ';
  }
  ul.lst-kix_list_1-2 {
    list-style-type: none;
  }
  ul.lst-kix_list_5-3 {
    list-style-type: none;
  }
  ul.lst-kix_list_1-7 {
    list-style-type: none;
  }
  .lst-kix_list_3-3 > li:before {
    content: '\0025cf  ';
  }
  ul.lst-kix_list_5-4 {
    list-style-type: none;
  }
  ul.lst-kix_list_1-8 {
    list-style-type: none;
  }
  ul.lst-kix_list_5-1 {
    list-style-type: none;
  }
  .lst-kix_list_8-0 > li:before {
    content: '\0025cf  ';
  }
  ul.lst-kix_list_1-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_5-2 {
    list-style-type: none;
  }
  ul.lst-kix_list_1-6 {
    list-style-type: none;
  }
  .lst-kix_list_8-7 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_3-8 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_8-5 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_8-6 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_8-3 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_3-6 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_3-7 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_8-4 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_8-8 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_5-0 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_4-8 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_5-3 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_4-7 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_5-2 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_5-1 > li:before {
    content: 'o  ';
  }
  ul.lst-kix_list_4-8 {
    list-style-type: none;
  }
  .lst-kix_list_5-7 > li:before {
    content: 'o  ';
  }
  ul.lst-kix_list_8-4 {
    list-style-type: none;
  }
  ul.lst-kix_list_8-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-6 {
    list-style-type: none;
  }
  .lst-kix_list_5-6 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_5-8 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_8-2 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_8-3 {
    list-style-type: none;
  }
  ul.lst-kix_list_8-8 {
    list-style-type: none;
  }
  ul.lst-kix_list_8-6 {
    list-style-type: none;
  }
  ul.lst-kix_list_8-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-0 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-1 {
    list-style-type: none;
  }
  .lst-kix_list_5-4 > li:before {
    content: 'o  ';
  }
  ul.lst-kix_list_4-4 {
    list-style-type: none;
  }
  .lst-kix_list_5-5 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_8-0 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_8-1 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-2 {
    list-style-type: none;
  }
  ul.lst-kix_list_4-3 {
    list-style-type: none;
  }
  .lst-kix_list_6-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_6-3 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_6-0 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_6-4 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_6-2 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_6-8 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_6-5 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_6-7 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_7-0 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_6-6 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_2-6 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_2-7 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_7-4 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_7-6 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_2-4 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_2-5 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_2-8 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_7-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_7-5 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_7-2 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_7-3 > li:before {
    content: '\0025cf  ';
  }
  ul.lst-kix_list_7-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-6 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-3 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-4 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-8 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-8 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-1 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-2 {
    list-style-type: none;
  }
  .lst-kix_list_7-8 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_3-0 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-1 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-2 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-6 {
    list-style-type: none;
  }
  ul.lst-kix_list_3-3 {
    list-style-type: none;
  }
  ul.lst-kix_list_7-0 {
    list-style-type: none;
  }
  .lst-kix_list_7-7 > li:before {
    content: 'o  ';
  }
  ul.lst-kix_list_3-4 {
    list-style-type: none;
  }
  .lst-kix_list_4-0 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_4-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_4-4 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_4-3 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_4-5 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_4-2 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_4-6 > li:before {
    content: '\0025cf  ';
  }
  ul.lst-kix_list_6-6 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-4 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-8 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-5 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-8 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-2 {
    list-style-type: none;
  }
  .lst-kix_list_1-0 > li:before {
    content: '\0025cf  ';
  }
  ul.lst-kix_list_2-3 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-0 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-1 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-2 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-6 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-3 {
    list-style-type: none;
  }
  .lst-kix_list_1-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_1-2 > li:before {
    content: '\0025aa  ';
  }
  ul.lst-kix_list_2-7 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-0 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-4 {
    list-style-type: none;
  }
  ul.lst-kix_list_6-1 {
    list-style-type: none;
  }
  ul.lst-kix_list_2-5 {
    list-style-type: none;
  }
  .lst-kix_list_1-3 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_1-4 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_1-7 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_1-5 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_1-6 > li:before {
    content: '\0025cf  ';
  }
  li.li-bullet-0:before {
    margin-left: -18pt;
    white-space: nowrap;
    display: inline-block;
    min-width: 18pt;
  }
  .lst-kix_list_2-0 > li:before {
    content: '\0025cf  ';
  }
  .lst-kix_list_2-1 > li:before {
    content: 'o  ';
  }
  .lst-kix_list_1-8 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_2-2 > li:before {
    content: '\0025aa  ';
  }
  .lst-kix_list_2-3 > li:before {
    content: '\0025cf  ';
  }
  ol {
    margin: 0;
    padding: 0;
  }
  table td,
  table th {
    padding: 0;
  }
  .c21 {
    border-right-style: solid;
    padding: 0pt 5.4pt 0pt 5.4pt;
    border-bottom-color: #000000;
    border-top-width: 1pt;
    border-right-width: 1pt;
    border-left-color: #000000;
    vertical-align: top;
    border-right-color: #000000;
    border-left-width: 1pt;
    border-top-style: solid;
    border-left-style: solid;
    border-bottom-width: 1pt;
    width: 296.9pt;
    border-top-color: #000000;
    border-bottom-style: solid;
  }
  .c14 {
    border-right-style: solid;
    padding: 0pt 5.4pt 0pt 5.4pt;
    border-bottom-color: #000000;
    border-top-width: 1pt;
    border-right-width: 1pt;
    border-left-color: #000000;
    vertical-align: top;
    border-right-color: #000000;
    border-left-width: 1pt;
    border-top-style: solid;
    border-left-style: solid;
    border-bottom-width: 1pt;
    width: 170.6pt;
    border-top-color: #000000;
    border-bottom-style: solid;
  }
  .c22 {
    -webkit-text-decoration-skip: none;
    font-weight: 400;
    text-decoration: underline;
    vertical-align: baseline;
    text-decoration-skip-ink: none;
    font-style: normal;
  }
  .c20 {
    margin-left: 36pt;
    padding-top: 0pt;
    padding-left: 0pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c8 {
    padding-top: 0pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
    height: 11pt;
  }
  .c37 {
    padding-top: 0pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
    margin-right: 7.2pt;
  }
  .c11 {
    padding-top: 0.5pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
    margin-right: 3.6pt;
  }
  .c34 {
    padding-top: 12.9pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c28 {
    padding-top: 0.4pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c36 {
    padding-top: 0pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c4 {
    padding-top: 12.8pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c33 {
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-style: normal;
  }
  .c42 {
    padding-top: 0.2pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c30 {
    padding-top: 12.9pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c13 {
    padding-top: 0.5pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c15 {
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-style: normal;
  }
  .c3 {
    padding-top: 0.5pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c2 {
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-style: normal;
  }
  .c26 {
    padding-top: 0.6pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c31 {
    padding-top: 0pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c1 {
    padding-top: 13.3pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c35 {
    padding-top: 0.3pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c19 {
    padding-top: 13.8pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c16 {
    padding-top: 13.6pt;
    padding-bottom: 0pt;

    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c29 {
    text-decoration-skip-ink: none;
    -webkit-text-decoration-skip: none;
    font-weight: 700;
    text-decoration: underline;
  }
  .c38 {
    margin-left: -5.4pt;
    border-spacing: 0;
    border-collapse: collapse;
    margin-right: auto;
  }
  .c18 {
    text-decoration-skip-ink: none;
    -webkit-text-decoration-skip: none;
    color: #0563c1;
    text-decoration: underline;
  }
  .c12 {
    background-color: #ffffff;
    max-width: 468pt;
    padding: 72pt 72pt 53.2pt 72pt;
  }
  .c5 {
    font-weight: 400;
  }
  .c6 {
    padding: 0;
    margin: 0;
  }
  .c9 {
    color: inherit;
    text-decoration: inherit;
  }
  .c24 {
    font-weight: 700;
  }
  .c17 {
    font-weight: 700;
  }
  .c7 {
    font-weight: 400;
  }
  .c27 {
    margin-left: 36pt;
    padding-left: 0pt;
  }
  .c41 {
    height: 90pt;
  }
  .c32 {
    font-weight: 700;
  }
  .c10 {
    height: 11pt;
  }
  .c23 {
    height: 135pt;
  }
  .c0 {
    color: #000000;
  }
  .c25 {
    height: 15pt;
  }
  .c39 {
    height: 45pt;
  }
  .c40 {
    height: 105pt;
  }
  .title {
    padding-top: 24pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 6pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .subtitle {
    padding-top: 18pt;
    color: #666666;
    padding-bottom: 4pt;

    page-break-after: avoid;
    font-style: italic;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  li {
    color: #000000;
  }
  p {
    margin: 0;
    color: #000000;
  }
  h1 {
    padding-top: 24pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 6pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h2 {
    padding-top: 18pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 4pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h3 {
    padding-top: 14pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 4pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h4 {
    padding-top: 12pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 2pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h5 {
    padding-top: 11pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 2pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h6 {
    padding-top: 10pt;
    color: #000000;
    font-weight: 700;
    padding-bottom: 2pt;

    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
}
</style>
